module.exports = __webpack_public_path__ + "img/robort.77e0680c.png";